const Login = {
  UserName: "Login.UserName",
  Password: "Login.Password",
  Login: "Login.Login",
  ForgotPassword: "Login.ForgotPassword",
  LoginWithBankId: "Login.LoginWithBankId",
  LoginWithQR: "Login.LoginWithQR",
  LoginWithPassword: "Login.LoginWithPassword",
  RememberMe: "Login.RememberMe",
  LoginMessage: "Login.LoginMessage",
  LoginTitle: "Login.LoginTitle",
  AboutBubbleText: "Login.AboutBubbleText",
  AboutText: "Login.AboutText",
  SupportHelpText: "Login.SupportHelpText",
  CancelLogin: "Login.CancelLogin",
  Result_1: "Login.Result_1",
  Result_2: "Login.Result_2",
  Result_3: "Login.Result_3",
  Result_4: "Login.Result_4",
  Result_5: "Login.Result_5",
  Result_6: "Login.Result_6",
  Result_7: "Login.Result_7",
  OpenMobileBankId: "Login.OpenMobileBankId",
  OpenBankId: "Login.OpenBankId",
  RequestPasswordTitle: "Login.RequestPasswordTitle",
  RequestPasswordMessage: "Login.RequestPasswordMessage",
  Send: "Login.Send",
  Email: "Login.Email",
  CheckYourMail: "Login.CheckYourMail",
  CheckYourMailMessage: "Login.CheckYourMailMessage",
  BackToLogin: "Login.BackToLogin",
  NewPassword: "Login.NewPassword",
  ConfirmPassword: "Login.ConfirmPassword",
  Title: "Login.Title",
  PasswordResetSuccessMessage: "Login.PasswordResetSuccessMessage",
  BankIdLoginMessage: "Login.BankIdLoginMessage",
  LoginWithPersonalNumber: "Login.LoginWithPersonalNumber",
  SelectCompany: "Login.SelectCompany",
  SelectCompanyDescription: "Login.SelectCompanyDescription",
  }
export default Login;